<template>
  <v-card class="pa-3">
    <v-card-title class="custom-color">
      Change password
    </v-card-title>

    <v-alert v-if="messages.length > 0" class="mx-4" type="error">
      <ul>
        <li v-for="message in messages" v-bind:key="message">{{ message }}</li>
      </ul>
    </v-alert>

    <v-card-text>
      <v-row class="mb-0 pb-0">
        <v-col class="mb-0 pb-0">
          <v-text-field
            v-model="changePassword.oldPassword"
            type="password"
            label="Old password"
            required
          />
        </v-col>
      </v-row>

      <v-row class="my-0 py-0 px-3">
        <v-text-field
          v-model="changePassword.newPassword"
          v-bind:class="{ 'me-2': spacing }"
          hint="Password must have between 8 and 16 characters, and it must contain at least: a capital letter, a number and a symbol (-!@#$%^&_*)"
          type="password"
          label="New password"
          required
        />
        <v-text-field
          v-model="confirm"
          v-bind:class="{ 'ms-2': spacing }"
          hint="Password must have between 8 and 16 characters, and it must contain at least: a capital letter, a number and a symbol (-!@#$%^&_*)"
          type="password"
          label="Confirm new password"
          required
        />
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 py-4">
      <v-spacer />
      <v-btn v-on:click="$emit('close')" elevation="0" class="me-2" color="white">
        Cancel
      </v-btn>
      <v-btn v-on:click="applyChanges" v-bind:loading="loading" color="primary" dark>
        Change
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.custom-color {
  color: #00303c;
}
</style>

<script>
import ChangePassword from "../models/ChangePassword";
import ApiRequests from "../utils/apiRequests";

export default {
  name: "ChangePassword",

  data: () => ({
    loading: false,
    confirm: "",
    messages: [],
    changePassword: ChangePassword.create()
  }),

  computed: {
    spacing () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs": return false;
        case "sm": return false;
        default: return true;
      }
    }
  },

  methods: {
    applyChanges () {
      this.messages = [];

      if (this.valid()) {
        this.toggleLoading();
        ApiRequests.changePassword(
          this.changePassword.passwordDataObject,
          () => {
            this.toggleLoading();
            this.$emit("changed");
          },
          (error) => {
            console.error(error);
            if (error.response != undefined && error.response.status == 404) {
              this.messages = ["Incorrect old password"];
            } else {
              this.messages = ["Something went wrong, retry later"];
            }

            this.toggleLoading();
          }
        );
      }
    },
    valid () {
      const validChange = this.changePassword.validate();
      const c = this.confirm == this.changePassword.newPassword;

      if (!c) { validChange.errors.push("Password not confirmed"); }

      this.messages = validChange.errors;

      return validChange.valid && c;
    },
    toggleLoading () {
      this.loading = !this.loading;
      this.$store.commit("setLoading", this.loading);
    }
  }
};
</script>
